import { ImportMessage, NotificationType } from '../Types/Notifications.types';
import { handleInputNotification } from '../Slices/Dataset.slice';
import { fetchNotificationsByJobid, setNewNotification } from '../Slices/Notifications.slice';
import {
	handleGetStatusDetail,
	setTemporaryImportNotificationStatusWidgetState
} from '../../component/status-widget/statusWidget.slice';
import { AppDispatch } from '../../app/store';
import { Guid } from 'guid-typescript';
import { showErrorSnackbar, showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';
import { Messages } from '../../Constants/Messages';
import { runCalculationCall } from '../../api/calculation/calculationController-api';
import { setCalculationInProgress, setImportEnabled, setRecentCalcRunState, setIsTestCaseRunInProgress } from '../../component/TopMenu/CalculationRun.slice';
import { setTestCaseStatus } from '../Slices/SanityCheck.slice';
import { TestCaseStatus, TestCaseStatusDictionary } from '../Types/SanityCheck.types';
import { updateTestCaseExecutionStatusUsingTestCaseId } from '../../api/SanityCheck/SanityCheck.api';

const updateTestCaseStatus = async (testCaseId: string, status: number, dispatch: AppDispatch) => {
	const result = await updateTestCaseExecutionStatusUsingTestCaseId(testCaseId, status);
	if (result.Success) {
		dispatch(setIsTestCaseRunInProgress(false));
		return true;
	}
	showErrorSnackbar(dispatch, Messages.UNABLE_TO_UPDATE_TESTCASE_STATUS);
	return false;
};

export async function addHandleImportNotification(importMessage: ImportMessage, dispatch: AppDispatch) {
	if (importMessage.isTestImport && importMessage.message.includes('initiated')) {
		dispatch(setTestCaseStatus(TestCaseStatus.Importing));
	}

	dispatch(
		handleInputNotification({
			importMessage: importMessage,
			notificationType: NotificationType.Group,
		}),
	);
	dispatch(
		setTemporaryImportNotificationStatusWidgetState({
			hierarchyLevelId: Guid.parse(importMessage.groupId),
			currentlyWith: importMessage.importedBy,
			lastChange: new Date(importMessage.importedOn),
		}),
	);
	dispatch(handleGetStatusDetail(Guid.parse(importMessage.groupId.toLowerCase())));
	dispatch(fetchNotificationsByJobid(importMessage.groupId.toLowerCase()));
	dispatch(setNewNotification());
	if (importMessage.message.includes('failed')) {
		showErrorSnackbar(dispatch, Messages.IMPORT_FAILED);
		if (importMessage.isTestImport) {
			await updateTestCaseStatus(
				importMessage?.testCaseId == null ? '' : importMessage.testCaseId.toString(),
				TestCaseStatusDictionary.FailedDueToImportError,
				dispatch
			);
			dispatch(setTestCaseStatus(TestCaseStatus.FailedImportError));
			dispatch(setIsTestCaseRunInProgress(false));
		}
		return;
	}
	if (importMessage.message.includes('cannot calculate') && importMessage.isTestImport) {
		showErrorSnackbar(dispatch, Messages.IMPORT_SUCCEEDED_BUT_CALCULATION_FAILED);
		await updateTestCaseStatus(
			importMessage?.testCaseId == null ? '' : importMessage.testCaseId.toString(),
				TestCaseStatusDictionary.FailedDueToImportError,
				dispatch
			);
			dispatch(setTestCaseStatus(TestCaseStatus.FailedImportError));
			dispatch(setIsTestCaseRunInProgress(false));
			return;
	}
	if (importMessage.isTestImport) {
		dispatch(setTestCaseStatus(TestCaseStatus.Calculating));
		
		const data = {
			JobId: importMessage.groupId.toLowerCase(),
			Settings: {
				ClientId: importMessage.clientId,
				ImportId: importMessage.importId,
				TestCaseId: importMessage?.testCaseId == null ? Guid.EMPTY : importMessage.testCaseId,
			},
		};
		const runCalculation = async() => {
			const result = await runCalculationCall(data);
			if (result.Success) {
				showSuccessSnackbar(dispatch, Messages.CALCULATIONS_INITIATED);
				return;
			}
			dispatch(setCalculationInProgress(false));
			showErrorSnackbar(dispatch, Messages.UNABLE_TO_RUN_CALCULATION);
					await updateTestCaseStatus(
				importMessage?.testCaseId == null ? '' : importMessage.testCaseId.toString(),
				TestCaseStatusDictionary.FailedDueToCalculationError,
				dispatch
			);
			dispatch(setImportEnabled(true));
			dispatch(setTestCaseStatus(TestCaseStatus.FailedCalculationError));
			dispatch(setIsTestCaseRunInProgress(false));
			return;
		};
		runCalculation();
	}
}

export function addHandleUserImportSuccessNotification(importMessage: ImportMessage, dispatch: AppDispatch) {
	showSuccessSnackbar(dispatch, Messages.IMPORT_SUCCESSFUL);
	dispatch(
		handleInputNotification({
			importMessage: importMessage,
			notificationType: NotificationType.User,
		}),
	);
	dispatch(
		setTemporaryImportNotificationStatusWidgetState({
			hierarchyLevelId: Guid.parse(importMessage.groupId),
			currentlyWith: importMessage.importedBy,
			lastChange: new Date(importMessage.importedOn),
		}),
	);
	dispatch(handleGetStatusDetail(Guid.parse(importMessage.groupId.toLowerCase())));
	dispatch(fetchNotificationsByJobid(importMessage.groupId));
	dispatch(setNewNotification());
}